import { IFormValuesJimpiFilter, IFormValuesTuiFilter } from "./types";
import * as yup from "yup";

export const JIMPI_FILTER_FORM_INITIAL_VALUE: IFormValuesJimpiFilter = {
    filename: '',
    importDateFrom: null,
    importDateTo: null,
    skipped: null,
    technicalError: null,
    businessError: null,
    tenants: [],
    dealers: []
}

export const TUI_FILTER_FORM_INITIAL_VALUE: IFormValuesTuiFilter = {
    filename: '',
    importDateFrom: null,
    importDateTo: null,
    skipped: null,
    technicalError: null,
    businessError: null,
    tenants: [],
    dealers: []
}

/* Yup Validation Schema */

export const SEARCH_JIMPI_FORM_VALIDATION_SCHEMA = yup.object()
	.shape({
		importDateFrom: yup
            .date()
            .typeError("message.validation.invalid_date")
            .nullable()
            .test(
                "testJimpiImportDateFrom",
                "message.validation.invalid_date",
                (value, context) => {
                    return (
                        !value ||
                        !context.parent.importDateTo ||
                        value <= context.parent.importDateTo
                    );
                }
            ),
			importDateTo: yup
            .date()
            .typeError("message.validation.invalid_date")
            .nullable()
            .test(
                "testJimpiImportDateTo",
                "message.validation.invalid_date",
                (value, context) => {
                    return (
                        !value ||
                        !context.parent.importDateFrom ||
                        value >= context.parent.importDateFrom
                    );
                }
            ),
            tenants: yup
                .array()
                .min(1, "message.validation.required")
	});

    export const SEARCH_TUI_FORM_VALIDATION_SCHEMA = yup.object()
	.shape({
		importDateFrom: yup
            .date()
            .typeError("message.validation.invalid_date")
            .nullable()
            .test(
                "testTuiImportDateFrom",
                "message.validation.invalid_date",
                (value, context) => {
                    return (
                        !value ||
                        !context.parent.importDateTo ||
                        value <= context.parent.importDateTo
                    );
                }
            ),
			importDateTo: yup
            .date()
            .typeError("message.validation.invalid_date")
            .nullable()
            .test(
                "testTuiImportDateTo",
                "message.validation.invalid_date",
                (value, context) => {
                    return (
                        !value ||
                        !context.parent.importDateFrom ||
                        value >= context.parent.importDateFrom
                    );
                }
            ),
            tenants: yup
                .array()
                .min(1, "message.validation.required")
	});